<template>
  <div class="container register">
    <v-card max-width="60%" class="logincard mx-auto">
      <v-card-title
        class="loginmain justify-center text-white"
        style="font-size: 30px; font-family: 'Nunito', sans-serif"
      >
        <v-img class="imagelogin" max-width="15%" src="/img/Bripl3.png" />
      </v-card-title>
      <div class="ml-5 mr-5 mt-8">
        <v-card-text>
          <v-row>
            <v-col>
              <v-text-field
                type="number"
                required
                prepend-icon="mdi-account"
                label="Enter Stb Number"
                v-model="customerDataBySerialNo"
                placeholder="Enter Stb Number"
              />
            </v-col>
            <v-col md="1">
              <v-card-text> OR </v-card-text>
            </v-col>
            <v-col>
              <v-text-field
                required
                prepend-icon="mdi-account"
                label="Enter Customer Id"
                v-model="customerData"
                placeholder="Enter Customer Id"
              />
            </v-col>
          </v-row>
        </v-card-text>
      </div>
      <v-card-actions>
        <v-row justify="center" v-if="!loading">
          <Button
            cssClass="mb-3 mr-2 ml-2 login"
            rounded
            :disabled="checkKey"
            @click="getCustomerData()"
            label="Quick Pay"
            color="primary"
          />
        </v-row>
        <div style="margin: auto" v-else>
          <v-progress-circular indeterminate />
        </div>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import Button from "@/components/Elements/Button.vue";
export default {
  data() {
    return {
      loading: false,
      customerData: "",
      customerDataBySerialNo: "",
    };
  },
  components: {
    Button,
  },
  computed: {
    checkKey() {
      if (this.customerData === "" && this.customerDataBySerialNo === "") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async getCustomerData() {
      this.$store.commit("auth/resetCustomerData", {});
      if (this.customerData !== "" && this.customerDataBySerialNo === "") {
        await this.$store
          .dispatch("auth/fetchCustomerData", this.customerData)
          .then((res) => {
            let customerdata = this.$store.state["auth"].customerData;
            this.$store.commit("auth/setPaymentData", {
              customerId: customerdata.customerno,
              stdNo: "123456",
              mobile: customerdata.contactinfo.mobilephone,
              email: customerdata.contactinfo.email,
              name: customerdata.firstname,
            });
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Wrong input please try again...",
            });
          });
      } else if (
        this.customerDataBySerialNo !== "" &&
        this.customerData === ""
      ) {
        await this.$store
          .dispatch(
            "auth/fetchCustomerDataBySerialNo",
            this.customerDataBySerialNo
          )
          .then((res) => {
            let customerdata = this.$store.state["auth"].customerDataBySerialNo;
            console.log(customerdata);
            this.$store.commit("auth/setPaymentData", {
              customerId: customerdata.customerno,
              stdNo: "123456",
              mobile: customerdata.contactinfo.mobilephone,
              email: customerdata.contactinfo.email,
              name: customerdata.firstname,
            });
          })
          .catch((er) => {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Wrong input please try again...",
            });
          });
      } else if (
        this.customerData !== "" &&
        this.customerDataBySerialNo !== ""
      ) {
        await this.$store
          .dispatch("auth/fetchCustomerData", this.customerData)
          .then((res) => {
            let customerdata = this.$store.state["auth"].customerData;
            this.$store.commit("auth/setPaymentData", {
              customerId: customerdata.customerno,
              stdNo: "123456",
              mobile: customerdata.contactinfo.mobilephone,
              email: customerdata.contactinfo.email,
              name: customerdata.firstname,
            });
          })
          .catch((err) => {
            this.$swal({
              icon: "error",
              title: "Oops...",
              text: "Wrong input please try again...",
            });
          });
      }
      console.log(this.$store.state["auth"].storePaymentData.customerId);
      if (this.$store.state["auth"].storePaymentData.customerId) {
        this.$router.push({
          path: "/quick-pay/plan-details",
        });
      } else {
      }

      console.log(this.$store.state["auth"].storePaymentData);
      // console.log("2", this.$store.state["auth"].customerDataBySerialNo);
    },
  },
  async mounted() {
    this.$store.commit("auth/resetCustomerData", {});
  },
};
</script>
<style scoped>
.register {
  background-image: url("/img/authentication.jpg");
  background-size: cover;
  background-position: center;
  max-width: 100%;
  height: 100% !important;
}
.logincard {
  margin-top: 4rem !important;
}
.imagelogin {
  margin-top: -20px !important;

  margin-bottom: -20px !important;
}
</style>
<style>
.theme--light.v-input:not(.v-input--is-disabled) input,
.theme--light.v-input:not(.v-input--is-disabled) textarea {
  font-size: 14px !important;
}

.v-btn:focus {
  outline: none !important;
}

.login {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}

.loginmain {
  background-image: linear-gradient(
    225deg,
    #59065d 0%,
    #8d0b93 50%,
    #061d48 100%
  );
  padding: 30px 10px !important;
}
</style>
